import { Col, Container, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { GetMemberCarePlanAPI } from '../../helpers/APIS/CommonApisSchema';
import { SelectFullStateOfThisAPI } from '../../Store/callAPI/selectors';
import { DataKey } from '../../Store/callAPI/allAPIs';

const StaticFooter = () => {
    const GetMemberCarePlanAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, GetMemberCarePlanAPI));
    const carePlanData = GetMemberCarePlanAPIData?.[DataKey]?.data;

    return (
        <footer className="footer bg-dark w-100 position-md-fixed position-static bottom-0 py-2 ">
            <Container fluid className="max-width-1920">
                <Row className="align-items-center">
                    <Col md={6} className="text-white text-center text-md-start mb-2 mb-md-0">
                        {new Date().getFullYear()} © GGH.
                    </Col>
                    <Col md={6} className="text-white">
                        <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-center gap-2 gap-md-4">
                            <div className="d-flex align-items-center">
                                <i className="fa-regular fa-circle-question me-2 fs-5"></i>
                                <span>Need help with your care plan?</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <i className="fa-solid fa-phone me-2"></i>
                                <a href={`tel:+1${carePlanData?.ccContactNumber}`} className="text-white text-decoration-none">
                                    {carePlanData?.ccContactNumber ? `+1 ${carePlanData?.ccContactNumber}` : 'N/A'}
                                </a>
                            </div>
                            <div className="d-flex align-items-center">
                                <i className="fa-regular fa-envelope me-2"></i>
                                <a href={`mailto:${carePlanData?.careCoordinatorEmail}`} className="text-white text-decoration-none">
                                    {carePlanData?.careCoordinatorEmail ? carePlanData?.careCoordinatorEmail : 'N/A'}
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default StaticFooter;
